import { useState, useCallback } from 'react';
import { useData } from '../../context/DataContext';
import './Testimonials.css';

export default function Testimonials() {
  const { data } = useData();
  const testimonials = data?.testimonials || [];
  const [current, setCurrent] = useState(0);

  const prev = useCallback(() => {
    setCurrent(c => (c === 0 ? testimonials.length - 1 : c - 1));
  }, [testimonials.length]);

  const next = useCallback(() => {
    setCurrent(c => (c === testimonials.length - 1 ? 0 : c + 1));
  }, [testimonials.length]);

  return (
    <section className="section testimonials">
      <div className="container">
        <div className="section-title section-title--center">
          <span className="section-title__label">Testimonials</span>
          <h2 className="section-title__heading">Kind Words</h2>
        </div>

        <div className="testimonials__carousel">
          <div className="testimonials__track" style={{ transform: `translateX(-${current * 100}%)` }}>
            {testimonials.map(t => (
              <div key={t.id} className="testimonials__slide">
                <div className="testimonials__card">
                  <div className="testimonials__header">
                    <div className="testimonials__avatar">
                      {t.name.charAt(0)}
                    </div>
                    <div>
                      <h4 className="testimonials__name">{t.name}</h4>
                      <p className="testimonials__role">{t.role}</p>
                      <p className="testimonials__location">{t.location}</p>
                    </div>
                  </div>
                  <p className="testimonials__text">&ldquo;{t.text}&rdquo;</p>
                  <div className="testimonials__stars">
                    {[1, 2, 3, 4, 5].map(star => (
                      <span key={star} className={`testimonials__star ${star <= t.rating ? 'testimonials__star--filled' : ''}`}>
                        ★
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="testimonials__controls">
            <button className="testimonials__btn" onClick={prev} aria-label="Previous testimonial">
              ← Prev
            </button>
            <div className="testimonials__dots">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  className={`testimonials__dot ${i === current ? 'testimonials__dot--active' : ''}`}
                  onClick={() => setCurrent(i)}
                  aria-label={`Go to testimonial ${i + 1}`}
                />
              ))}
            </div>
            <button className="testimonials__btn" onClick={next} aria-label="Next testimonial">
              Next →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
